/** German UI text, keyed by the English source string. Missing keys fall back to English. */
export const DE: Record<string, string> = {
  // shell, login
  'Platform console': 'Plattformkonsole',
  'Platform operator': 'Plattformbetreiber',
  Sales: 'Vertrieb',
  'Sales director': 'Sales Director',
  'General manager': 'General Manager',
  'sales director': 'Sales Director',
  'Pricing admin': 'Pricing-Admin',
  'Price finder': 'Preisfinder',
  'My quotes': 'Meine Angebote',
  Escalations: 'Eskalationen',
  Team: 'Team',
  Teams: 'Teams',
  Quotes: 'Angebote',
  'Below-floor requests': 'Anfragen unter dem Floor',
  'Model versions': 'Modellversionen',
  'Reference data': 'Stammdaten',
  Users: 'Benutzer',
  'Audit log': 'Audit-Log',
  Tenants: 'Mandanten',
  Operators: 'Betreiber',
  Language: 'Sprache',
  'Toggle theme': 'Farbschema wechseln',
  Light: 'Hell',
  Dark: 'Dunkel',
  'Sign out': 'Abmelden',
  'Sign in': 'Anmelden',
  'Platform sign-in': 'Plattform-Anmeldung',
  'Signing in…': 'Anmeldung…',
  'Continue with Microsoft Entra ID': 'Mit Microsoft Entra ID fortfahren',
  'or with a password': 'oder mit Passwort',
  Email: 'E-Mail',
  Password: 'Passwort',
  'Tenant handle': 'Mandantenkürzel',
  'For example: demo-industries': 'Zum Beispiel: demo-industries',
  'This email exists in more than one tenant. Add the tenant handle.': 'Diese E-Mail-Adresse gibt es in mehreren Mandanten. Bitte das Mandantenkürzel angeben.',
  'Platform operator? Sign in here': 'Plattformbetreiber? Hier anmelden',
  'Back to tenant sign-in': 'Zurück zur Mandanten-Anmeldung',
  'Price governance for sales teams.': 'Preisgovernance für Vertriebsteams.',

  // shared
  All: 'Alle',
  'searching here': 'Suche hier',
  'searching everywhere': 'Suche überall',
  'No matches': 'Keine Treffer',
  Cancel: 'Abbrechen',
  Back: 'Zurück',
  Open: 'Öffnen',
  'Saving…': 'Wird gespeichert…',
  Note: 'Notiz',
  'Note (optional)': 'Notiz (optional)',
  'Note (required)': 'Notiz (erforderlich)',
  Optional: 'Optional',
  Reason: 'Begründung',
  Status: 'Status',
  Outcome: 'Ergebnis',
  When: 'Wann',
  By: 'Von',
  by: 'von',
  at: 'zu',
  Article: 'Artikel',
  Customer: 'Kunde',
  Target: 'Target',
  Ask: 'Ask',
  Floor: 'Floor',
  Cost: 'Cost',
  'per unit': 'pro Einheit',
  unit: 'Einheit',
  '€/unit': '€/Einheit',
  Units: 'Menge',
  Price: 'Preis',
  Margin: 'Marge',
  Revenue: 'Umsatz',
  Share: 'Anteil',
  Rep: 'Sales Rep',
  'vs target': 'ggü. Target',
  'vs floor': 'ggü. Floor',
  target: 'Target',
  floor: 'Floor',
  model: 'Modell',
  Version: 'Version',
  Level: 'Stufe',
  Driver: 'Treiber',
  Drivers: 'Treiber',
  Block: 'Block',
  Grain: 'Ebene',
  Line: 'Zeile',
  From: 'Von',
  To: 'Bis',
  Before: 'Vorher',
  After: 'Nachher',
  Move: 'Änderung',
  Setting: 'Einstellung',
  Name: 'Name',
  Role: 'Rolle',
  Decision: 'Entscheidung',
  Pending: 'Offen',
  pending: 'offen',
  Recorded: 'Erfasst',
  recorded: 'erfasst',
  approved: 'genehmigt',
  Approved: 'Genehmigt',
  rejected: 'abgelehnt',
  withdrawn: 'zurückgezogen',
  open: 'offen',
  won: 'gewonnen',
  lost: 'verloren',
  Won: 'Gewonnen',
  Lost: 'Verloren',
  'Won / lost': 'Gewonnen / verloren',
  Escalated: 'Eskaliert',
  escalated: 'eskaliert',
  Escalation: 'Eskalation',
  'Within your authority': 'In Ihrer Kompetenz',
  'Needs approval': 'Freigabe nötig',
  'Needs sales director approval': 'Freigabe durch Sales Director',
  'Needs general manager': 'Freigabe durch General Manager',
  'Beyond your authority. Recording this quote opens an escalation to your sales director.': 'Außerhalb Ihrer Kompetenz. Beim Erfassen wird eine Eskalation an Ihren Sales Director ausgelöst.',
  'Beyond your sales director’s authority. Recording this quote opens an escalation to the general manager.': 'Außerhalb der Kompetenz Ihres Sales Directors. Beim Erfassen wird eine Eskalation an den General Manager ausgelöst.',
  'This price is below every approval limit and blocked by policy. Raise the price.': 'Dieser Preis liegt unter jeder Freigabegrenze und ist per Richtlinie gesperrt. Bitte den Preis erhöhen.',
  'This price is below every approval limit and blocked by policy. Nothing was saved.': 'Dieser Preis liegt unter jeder Freigabegrenze und ist per Richtlinie gesperrt. Es wurde nichts gespeichert.',
  'general manager': 'General Manager',
  'To the general manager': 'An den General Manager',
  'To the sales director': 'An den Sales Director',
  'Approval limits': 'Freigabegrenzen',
  'The lowest price each role accepts on its own. Below the sales director’s limit the general manager decides; below the general manager’s limit nobody can.': 'Der niedrigste Preis, den jede Rolle selbst akzeptiert. Unter der Grenze des Sales Directors entscheidet der General Manager; unter dessen Grenze niemand.',
  'Sales rep': 'Sales Rep',
  Reference: 'Bezug',
  Direction: 'Richtung',
  Amount: 'Betrag',
  Unit: 'Einheit',
  below: 'unter',
  above: 'über',
  'no limit': 'keine Grenze',
  '% of the reference': '% des Bezugs',
  '% of {ref}': '% vom {ref}',
  'Capped at': 'Begrenzt auf',
  'No ceiling': 'Keine Obergrenze',
  '€ per unit': '€ pro Einheit',
  '% of the driver sum': '% der Treibersumme',
  'of the driver sum': 'der Treibersumme',
  'Below the floor': 'Unter dem Floor',
  'below floor': 'unter Floor',
  'below target': 'unter Target',
  'Below floor': 'Unter Floor',
  'Market situation': 'Marktsituation',
  'Structural position': 'Strukturelle Position',
  'Client context': 'Kundenkontext',
  'Deal context': 'Abschlusskontext',
  product: 'Artikel',
  customer: 'Kunde',
  market: 'Markt',
  deal: 'Abschluss',
  rep: 'Sales Rep',
  supervisor: 'Sales Director',
  admin: 'Admin',
  'ex works': 'ab Werk',
  delivered: 'frei Haus',
  basis: 'Basis',
  Basis: 'Basis',
  capped: 'gedeckelt',
  floored: 'angehoben',
  'by corridor': 'durch den Korridor',
  active: 'aktiv',
  draft: 'Entwurf',
  superseded: 'abgelöst',
  rolled_back: 'zurückgesetzt',
  imported: 'importiert',
  'hand-edited': 'manuell bearbeitet',
  '(no note)': '(keine Notiz)',

  // price finder
  'Browse product groups or search by name or SKU…': 'Produktgruppen durchsuchen oder nach Name oder Artikelnummer suchen…',
  'Search customer…': 'Kunde suchen…',
  'Recent pairs': 'Zuletzt verwendet',
  'Deal terms': 'Konditionen',
  Packaging: 'Verpackung',
  'Silo / bulk': 'Silo / lose',
  'Not set': 'Nicht gesetzt',
  'standing terms': 'Standardkonditionen',
  'Pricing…': 'Preis wird berechnet…',
  'This pair cannot be priced': 'Diese Kombination kann nicht bepreist werden',
  'A driver in the model has no rating at any level of its hierarchy. No partial price is shown.': 'Ein Treiber im Modell hat auf keiner Ebene seiner Hierarchie eine Bewertung. Es wird kein Teilpreis angezeigt.',
  '{n} driver(s) unrated for {product} × {customer}. Ask the pricing team to import ratings for the entities below.': '{n} Treiber ohne Bewertung für {product} × {customer}. Bitte das Pricing-Team, Bewertungen für die folgenden Einträge zu importieren.',
  'Looked for, in order': 'Gesucht, in dieser Reihenfolge',
  'no deal attribute supplied': 'kein Abschlussmerkmal übergeben',
  'Your price': 'Ihr Preis',
  'Type a price or drag the handle.': 'Preis eingeben oder den Regler ziehen.',
  'Record quote': 'Angebot erfassen',
  'Below target. Recording this quote opens an escalation to your sales director.': 'Unter dem Target. Beim Erfassen wird eine Eskalation an Ihren Sales Director ausgelöst.',
  'Below the floor. Recording this quote opens an escalation to the general manager.': 'Unter dem Floor. Beim Erfassen wird eine Eskalation an den General Manager ausgelöst.',
  'Quotes below the floor are blocked by policy. Raise the price or talk to your sales director.': 'Angebote unter dem Floor sind per Richtlinie gesperrt. Preis erhöhen oder mit Ihrem Sales Director sprechen.',
  'Quotes below the floor are blocked by policy. Nothing was saved.': 'Angebote unter dem Floor sind per Richtlinie gesperrt. Es wurde nichts gespeichert.',
  'Quote recorded at {price}, within your authority.': 'Angebot zu {price} erfasst, innerhalb Ihrer Kompetenz.',
  'Quote recorded at {price}. It needs approval; give your sales director the reason.': 'Angebot zu {price} erfasst. Es braucht eine Freigabe; nennen Sie Ihrem Sales Director den Grund.',
  'Quote recorded at {price}. It needs second-level approval; give the general manager the reason.': 'Angebot zu {price} erfasst. Es braucht die Freigabe des General Managers; nennen Sie den Grund.',
  'Competitor offer, tender, volume commitment…': 'Wettbewerbsangebot, Ausschreibung, Mengenzusage…',
  'Send escalation': 'Eskalation senden',
  'Floor above target.': 'Floor über dem Target.',
  'Any price below the floor needs the general manager.': 'Jeder Preis unter dem Floor braucht den General Manager.',
  'Pays today': 'Zahlt heute',
  'no sales history for this pair': 'keine Verkaufshistorie für diese Kombination',
  'Margin at your price': 'Marge bei Ihrem Preis',
  'Ships from': 'Lieferung ab',
  'Ex works, no transport': 'Ab Werk, ohne Transport',
  'Order quantity': 'Bestellmenge',
  'for volume tiers': 'für Mengenstaffeln',
  'Target ex works': 'Target ab Werk',
  Transport: 'Transport',
  'from {n} units': 'ab {n} Einheiten',
  'Target incl. transport': 'Target inkl. Transport',
  'Your price incl. transport': 'Ihr Preis inkl. Transport',
  'No postcode in the customer master; transport cannot be priced.': 'Keine Postleitzahl in den Kundenstammdaten; der Transport kann nicht bepreist werden.',
  'No route from {plant} to {zip}.': 'Keine Route von {plant} nach {zip}.',
  plants: 'Werke',

  // ladder
  'The ladder': 'Die Preisleiter',
  'Commercial uplift': 'Kommerzieller Aufschlag',
  Intercept: 'Konstante',
  'Base surcharge': 'Basiszuschlag',
  Corridor: 'Korridor',
  'Corridor, capped': 'Korridor, gedeckelt',
  'Corridor, floored': 'Korridor, angehoben',
  Uplift: 'Aufschlag',
  '€ surcharges': '€-Zuschläge',
  '{n} drivers': '{n} Treiber',
  'no effect': 'ohne Wirkung',

  // history
  'Loading history…': 'Historie wird geladen…',
  'This article at this customer': 'Dieser Artikel bei diesem Kunden',
  'This customer, all articles': 'Dieser Kunde, alle Artikel',
  'Price per unit': 'Preis pro Einheit',
  'Off list': 'Rabatt auf Liste',
  list: 'Liste',
  'Margin per unit': 'Marge pro Einheit',
  'Margin/unit': 'Marge/Einheit',
  'Realised €/unit': 'Erzielt €/Einheit',
  'Unit cost': 'Stückkosten',
  'Target now': 'Target heute',
  'No history for this article at this customer.': 'Keine Historie für diesen Artikel bei diesem Kunden.',
  'No history for this customer.': 'Keine Historie für diesen Kunden.',
  '{n} article(s)': '{n} Artikel',
  Across: 'Über',
  '{n} customers': '{n} Kunden',
  median: 'Median',
  'This customer pays': 'Dieser Kunde zahlt',
  'vs median · more than {p} of customers': 'ggü. Median · mehr als {p} der Kunden',

  // quotes
  'Team quotes': 'Angebote des Teams',
  'No quotes yet.': 'Noch keine Angebote.',
  Quoted: 'Angeboten',
  Band: 'Band',
  'Quoted {when} by {who}': 'Angeboten {when} von {who}',
  'Final price': 'Endpreis',
  'Save outcome': 'Ergebnis speichern',
  'PO received, lost to competitor…': 'Bestellung erhalten, an Wettbewerber verloren…',
  'Second level · below the floor': 'Zweite Stufe · unter dem Floor',
  'First level · below target': 'Erste Stufe · unter Target',
  requested: 'angefragt',
  'Asked for': 'Angefragt',

  // queue, escalation
  'Requests below the floor, from every team. Oldest first.': 'Anfragen unter dem Floor aus allen Teams. Älteste zuerst.',
  'Pending requests from {team}. Oldest first.': 'Offene Anfragen aus {team}. Älteste zuerst.',
  oldest: 'älteste',
  'nothing waiting': 'nichts offen',
  'Annualised at stake': 'Jahreswert im Spiel',
  'requested vs target, a year': 'angefragt ggü. Target, pro Jahr',
  Decided: 'Entschieden',
  'recent decisions': 'letzte Entscheidungen',
  '{n} pending': '{n} offen',
  'Nothing waiting.': 'Nichts offen.',
  Waiting: 'Wartet seit',
  'Article · customer': 'Artikel · Kunde',
  Annualised: 'Pro Jahr',
  'at {n} a year': 'bei {n} pro Jahr',
  'no volume in the last 12 months': 'keine Menge in den letzten 12 Monaten',
  '{n} without recent volume': '{n} ohne aktuelle Menge',
  'Recent decisions': 'Letzte Entscheidungen',
  'Asked → decided': 'Angefragt → entschieden',
  'Requested by {who}': 'Angefragt von {who}',
  waiting: 'wartet seit',
  'Back to queue': 'Zurück zur Liste',
  'The rep’s reason': 'Begründung des Sales Reps',
  'This rep this quarter': 'Dieser Sales Rep in diesem Quartal',
  since: 'seit',
  Decide: 'Entscheiden',
  'Approve at': 'Genehmigen zu',
  'Approve at a different price': 'Zu einem anderen Preis genehmigen',
  Reject: 'Ablehnen',
  Approve: 'Genehmigen',
  'Why, and for how long': 'Warum, und für wie lange',
  'The rep’s view, as priced': 'Die Sicht des Sales Reps, wie bepreist',

  // team view
  'All teams': 'Alle Teams',
  'quoted and realised prices against target': 'angebotene und erzielte Preise gegenüber dem Target',
  '{n} pending approval': '{n} warten auf Freigabe',
  'Avg gap vs target': 'Ø Abstand zum Target',
  'quoted or approved price': 'angebotener oder genehmigter Preis',
  'Inside the band': 'Im Band',
  'Inside band': 'Im Band',
  'concession rate': 'Konzessionsrate',
  'of quotes': 'der Angebote',
  'win rate on decided': 'Gewinnquote der entschiedenen',
  'no outcomes yet': 'noch keine Ergebnisse',
  'Realised gap': 'Erzielter Abstand',
  'final price vs target, won quotes': 'Endpreis ggü. Target, gewonnene Angebote',
  'By team': 'Nach Team',
  'By month': 'Nach Monat',
  'By rep': 'Nach Sales Rep',
  'Avg gap': 'Ø Abstand',
  'Approved / rejected': 'Genehmigt / abgelehnt',
  'mean (quoted − target) / target · share at or above target': 'Mittel (angeboten − Target) / Target · Anteil auf oder über Target',
  'gap vs target': 'Abstand zum Target',
  share: 'Anteil',
  'Share inside band': 'Anteil im Band',

  // admin: users, audit
  'Provision a user': 'Benutzer anlegen',
  'SSO users sign in with their Microsoft account once provisioned by email. A password is only needed without SSO.': 'SSO-Benutzer melden sich nach dem Anlegen per E-Mail mit ihrem Microsoft-Konto an. Ein Passwort ist nur ohne SSO nötig.',
  'Display name': 'Anzeigename',
  'Sales team': 'Vertriebsteam',
  'Password (optional)': 'Passwort (optional)',
  Create: 'Anlegen',
  all: 'alle',
  'Sign-in': 'Anmeldung',
  password: 'Passwort',
  'not yet': 'noch nicht',
  inactive: 'inaktiv',
  Everything: 'Alles',
  Imports: 'Importe',
  Actor: 'Wer',
  Action: 'Aktion',
  Entity: 'Objekt',
  'Before → after': 'Vorher → nachher',
  system: 'System',

  // admin: versions
  'Import payload': 'Modell importieren',
  'Open draft from active': 'Entwurf aus aktiver Version',
  'Import a payload from the calibration app': 'Modell aus der Kalibrierung importieren',
  'Validated against the schema on ingest; a failing payload is rejected whole. Creates a draft.': 'Wird beim Import gegen das Schema geprüft; ein fehlerhaftes Modell wird komplett abgelehnt. Erzeugt einen Entwurf.',
  'Validate and import': 'Prüfen und importieren',
  'Import a model': 'Modell importieren',
  'Choose file': 'Datei wählen',
  'The template is the active model, or all weights at zero when none is active. Change the weights and policy, then import it here. It arrives as a draft to review and publish.':
    'Die Vorlage ist das aktive Modell, oder alle Gewichte auf null, solange keines aktiv ist. Gewichte und Regeln anpassen und hier importieren. Es kommt als Entwurf zum Prüfen und Veröffentlichen.',
  Provenance: 'Herkunft',
  from: 'aus',
  '{n} weight(s) moved': '{n} Gewichte geändert',
  '{n} other': '{n} weitere',
  Published: 'Veröffentlicht',
  published: 'veröffentlicht',
  created: 'erstellt',
  'Roll back to this': 'Auf diese Version zurücksetzen',
  'Roll back to': 'Zurücksetzen auf',
  'The current active version is retired and this version’s ratings return. A reason is required and audited.': 'Die aktuell aktive Version wird abgelöst und die Bewertungen dieser Version kehren zurück. Eine Begründung ist erforderlich und wird protokolliert.',
  'Roll back': 'Zurücksetzen',
  'Compare two versions': 'Zwei Versionen vergleichen',
  'Choose…': 'Auswählen…',
  Compare: 'Vergleichen',
  'No differences.': 'Keine Unterschiede.',
  absent: 'nicht vorhanden',
  removed: 'entfernt',

  // admin: version editor
  Parent: 'Vorgänger',
  parent: 'Vorgänger',
  'ratings from': 'Bewertungen aus',
  immutable: 'unveränderlich',
  'All versions': 'Alle Versionen',
  Edit: 'Bearbeiten',
  'Draft note': 'Entwurfsnotiz',
  'What this revision is for': 'Wozu diese Überarbeitung dient',
  'Save draft': 'Entwurf speichern',
  'Discard changes': 'Änderungen verwerfen',
  'Delete draft': 'Entwurf löschen',
  'Delete this draft? Its edits are lost; the published versions stay as they are.': 'Diesen Entwurf löschen? Seine Änderungen gehen verloren; die veröffentlichten Versionen bleiben unverändert.',
  'Edits do not move live prices until the draft is published.': 'Änderungen wirken erst auf die Preise, wenn der Entwurf veröffentlicht ist.',
  'Store anyway': 'Trotzdem speichern',
  Weights: 'Gewichte',
  'Costs & uplift': 'Kosten & Aufschlag',
  Policy: 'Richtlinie',
  Payload: 'Rohdaten',
  'Log-space constant applied to every price before any driver. Enter as a percentage.': 'Konstante im Log-Raum, die vor allen Treibern auf jeden Preis wirkt. Als Prozentsatz eingeben.',
  'Euros per unit added with the absolute drivers, once per price.': 'Euro pro Einheit, zusammen mit den absoluten Treibern einmal pro Preis addiert.',
  relative: 'relativ',
  'absolute · €/unit': 'absolut · €/Einheit',
  'ratings resolving to this driver': 'Bewertungen, die auf diesen Treiber aufgelöst werden',
  ratings: 'Bewertungen',
  'Effect %': 'Wirkung %',
  'Effect €/unit': 'Wirkung €/Einheit',
  Stored: 'Gespeichert',
  'Cost overrides': 'Kostenüberschreibungen',
  'sku wins outright (EUR/unit); subCat and cat are multiplicative factors, sub-category first.': 'sku gilt absolut (EUR/Einheit); subCat und cat sind multiplikative Faktoren, Untergruppe zuerst.',
  'Applied last, most specific first: sub → cat → base. Rates as fractions (0.03 = 3 %).': 'Wird zuletzt angewandt, spezifischste Ebene zuerst: sub → cat → base. Raten als Bruch (0.03 = 3 %).',
  'The version as stored.': 'Die Version, wie gespeichert.',
  'Impact, before publishing': 'Auswirkung, vor der Veröffentlichung',
  'For each changed level: how many article–customer pairs move, their share of revenue, the change in target, and the largest movements.': 'Je geänderter Stufe: wie viele Artikel-Kunden-Paare sich bewegen, ihr Umsatzanteil, die Änderung des Targets und die größten Bewegungen.',
  'Computing…': 'Wird berechnet…',
  Recompute: 'Neu berechnen',
  'Compute impact': 'Auswirkung berechnen',
  'Save the draft first; the preview prices the saved draft.': 'Zuerst den Entwurf speichern; die Vorschau bepreist den gespeicherten Entwurf.',
  'Pairs priced': 'Bepreiste Paare',
  'unrated skipped': 'ohne Bewertung übersprungen',
  'Pairs moving': 'Bewegte Paare',
  'of revenue': 'des Umsatzes',
  'Aggregate Δ target': 'Δ Target gesamt',
  'at last year’s volumes': 'bei den Mengen des Vorjahres',
  'Aggregate Δ %': 'Δ % gesamt',
  'volume-weighted': 'mengengewichtet',
  'This draft is identical to its parent.': 'Dieser Entwurf ist identisch mit seinem Vorgänger.',
  pairs: 'Paare',
  'Revenue 12m': 'Umsatz 12 M',
  Publish: 'Veröffentlichen',
  'Makes this draft the active version. The current active version is retired. A note is required and audited.': 'Macht diesen Entwurf zur aktiven Version. Die bisherige aktive Version wird abgelöst. Eine Notiz ist erforderlich und wird protokolliert.',
  'Publish note': 'Veröffentlichungsnotiz',
  'Signed off by the pricing committee on …': 'Vom Pricing-Komitee freigegeben am …',
  'Save or discard your edits first.': 'Zuerst Änderungen speichern oder verwerfen.',
  'Compute the impact above before publishing.': 'Vor der Veröffentlichung die Auswirkung oben berechnen.',

  // admin: imports
  'A file is imported completely or not at all.': 'Eine Datei wird vollständig oder gar nicht importiert.',
  'Data status': 'Datenstand',
  'as of': 'Stand',
  Rows: 'Zeilen',
  Covers: 'Zeitraum',
  'Last import': 'Letzter Import',
  'Download template': 'Vorlage herunterladen',
  Current: 'Aktuell',
  Behind: 'Veraltet',
  Missing: 'Fehlt',
  orders: 'Aufträge',
  indices: 'Indizes',
  'linked to indices': 'mit Indexbezug',
  'with standing terms': 'mit Standardkonditionen',
  drivers: 'Treiber',
  Dataset: 'Datensatz',
  'Target model version': 'Ziel-Modellversion',
  'Ratings are keyed by version so a rollback restores the pair. Defaults to the active version.': 'Bewertungen sind an die Version gebunden, damit ein Zurücksetzen das Paar wiederherstellt. Standard ist die aktive Version.',
  'Active version': 'Aktive Version',
  'Choose file…': 'Datei wählen…',
  'or paste below': 'oder unten einfügen',
  'Ratings move live prices: preview first, then import.': 'Bewertungen verändern die Preise: zuerst Vorschau, dann importieren.',
  'Preview validates the file without writing.': 'Die Vorschau prüft die Datei, ohne zu schreiben.',
  'Checking…': 'Wird geprüft…',
  Preview: 'Vorschau',
  'Preview first': 'Zuerst Vorschau',
  'Importing…': 'Wird importiert…',
  Import: 'Importieren',
  'Valid.': 'Gültig.',
  'rows would be written': 'Zeilen würden geschrieben',
  '{n} dropped and counted': '{n} verworfen und gezählt',
  'Nothing has been changed yet.': 'Es wurde noch nichts geändert.',
  Ratings: 'Bewertungen',
  added: 'neu',
  changed: 'geändert',
  unchanged: 'unverändert',
  Prices: 'Preise',
  of: 'von',
  'pairs move': 'Paare bewegen sich',
  'unrated pairs': 'Paare ohne Bewertung',
  'Nothing was imported. Fix the rows below and try again.': 'Es wurde nichts importiert. Die folgenden Zeilen korrigieren und erneut versuchen.',
  Imported: 'Importiert',
  'rows into': 'Zeilen in',
  derived: 'abgeleitet',
  customers: 'Kunden',
  articles: 'Artikel',
  'monthly rows': 'Monatszeilen',
  'for version': 'für Version',
  '{n} rows dropped and counted.': '{n} Zeilen verworfen und gezählt.',
  'Dropped because': 'Verworfen, weil',
  'One file of order lines. Derives customers, articles (most frequent category, cost over the last twelve months) and the monthly history; keeps the lines for discount and benchmark analyses. Existing standing terms and index shares are kept.': 'Eine Datei mit Auftragszeilen. Leitet Kunden, Artikel (häufigste Kategorie, Kosten der letzten zwölf Monate) und die Monatshistorie ab; behält die Zeilen für Rabatt- und Benchmark-Analysen. Bestehende Standardkonditionen und Indexanteile bleiben erhalten.',
  'Import first: products reference these indices.': 'Zuerst importieren: Artikel verweisen auf diese Indizes.',
  'Shares must sum to 1 (± 0.001); every index must exist.': 'Anteile müssen sich zu 1 addieren (± 0,001); jeder Index muss existieren.',
  'Shares must sum to 1 (± 0.001); every index must exist. fixed_cost replaces the calculated cost and does not follow the indices; cost_factor multiplies it (1.05 = 5 % above).': 'Anteile müssen sich zu 1 addieren (± 0,001); jeder Index muss existieren. fixed_cost ersetzt die berechneten Kosten und folgt den Indizes nicht; cost_factor multipliziert sie (1,05 = 5 % darüber).',
  'All articles': 'Alle Artikel',
  'Applies to': 'Gilt für',
  'Add row': 'Zeile hinzufügen',
  'Latest sales to other customers': 'Letzte Verkäufe an andere Kunden',
  Undecided: 'Offen',
  'PPI': 'PPI',
  'Quoted PPI': 'PPI angeboten',
  'Your PPI': 'Ihr PPI',
  'PPI at your price': 'PPI bei Ihrem Preis',
  '100 = Target': '100 = Target',
  'final price ÷ target × 100, won quotes': 'Endpreis ÷ Target × 100, gewonnene Angebote',
  'PPI by month': 'PPI nach Monat',
  '6–12 months': '6–12 Monate',
  '3–6 months': '3–6 Monate',
  '0–3 months': '0–3 Monate',
  'Next 3 months': 'Nächste 3 Monate',
  'Months 3–6': 'Monate 3–6',
  'Months 6–12': 'Monate 6–12',
  'Source': 'Quelle',
  'e.g. exchange settlement': 'z. B. Börsen-Settlement',
  'Last update': 'Letzte Änderung',
  'Monthly inputs': 'Monatswerte',
  'Files': 'Dateien',
  'Index levels': 'Indexstände',
  'required': 'erforderlich',
  'optional': 'optional',
  'only without transactions': 'nur ohne Transaktionen',
  'entered monthly': 'monatlich erfasst',
  'Index': 'Index',
  'Articles': 'Artikel',
  'missing': 'fehlt',
  'New index, e.g. STEEL': 'Neuer Index, z. B. STEEL',
  'Add index': 'Index hinzufügen',
  'Territory': 'Gebiet',
  'All territories': 'Alle Gebiete',
  'Which index each article’s cost follows, and by what share; the rest of the cost stays fixed. fixed_cost replaces the calculated cost and does not follow the indices; cost_factor multiplies it (1.05 = 5 % above). The file is complete: an article it leaves out is costed at its plain average again.': 'Welchem Index die Kosten eines Artikels folgen und mit welchem Anteil; der Rest bleibt fix. fixed_cost ersetzt die berechneten Kosten und folgt den Indizes nicht; cost_factor multipliziert sie (1,05 = 5 % darüber). Die Datei ist vollständig: Ein nicht enthaltener Artikel wird wieder mit seinen Durchschnittskosten gerechnet.',
  'Governance': 'Governance',
  'Price rules': 'Preisregeln',
  'Ask above target': 'Ask über Target',
  'The ask is the target plus this share: the room to negotiate down to target.': 'Der Ask ist das Target plus dieser Anteil: der Spielraum bis zum Target.',
  'Corridor cap': 'Korridor-Obergrenze',
  'The target rises at most this much above the customer’s last price, adjusted for cost.': 'Das Target steigt höchstens so weit über den letzten Preis des Kunden, kostenbereinigt.',
  'Floor includes': 'Floor enthält',
  'The floor is cost plus these blocks and every € surcharge.': 'Der Floor besteht aus den Kosten plus diesen Blöcken und allen €-Zuschlägen.',
  'Cost movement since the last price': 'Kostenveränderung seit dem letzten Preis',
  'How the corridor carries cost changes since the customer’s last price.': 'Wie der Korridor Kostenänderungen seit dem letzten Preis des Kunden weitergibt.',
  'Pass on the cost change in €': 'Kostenänderung in € weitergeben',
  'Pass on the cost change as a % of the price': 'Kostenänderung prozentual auf den Preis',
  'Saved. Applies from the next price.': 'Gespeichert. Gilt ab dem nächsten Preis.',
  'Save': 'Speichern',
  'Remove': 'Entfernen',
  'Sub-category': 'Untergruppe',
  'Category': 'Kategorie',
  'Differs from the parent version.': 'Weicht von der Vorgängerversion ab.',
  'Standing terms are optional and default the deal attributes.': 'Standardkonditionen sind optional und setzen die Abschlussmerkmale vor.',
  'Rows with units ≤ 0 or revenue_net ≤ 0 are dropped and counted.': 'Zeilen mit units ≤ 0 oder revenue_net ≤ 0 werden verworfen und gezählt.',
  'Exactly one entity column per row. Unknown driver ids reject the file.': 'Genau eine Objektspalte pro Zeile. Unbekannte Treiber-IDs lehnen die Datei ab.',
  'Exactly one entity column per row.': 'Genau eine Objektspalte pro Zeile.',
  'Territory “*” is the fallback for the month.': 'Gebiet „*“ ist der Rückfall für den Monat.',
  'Cost per unit from a plant to a postcode or postcode prefix; the longest match wins. Rows with a higher min_qty are volume tiers.': 'Kosten pro Einheit von einem Werk zu einer Postleitzahl oder einem PLZ-Präfix; die längste Übereinstimmung gilt. Zeilen mit höherem min_qty sind Mengenstaffeln.',
}
